import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from '../../components/StatsTable';
import Graph from './components/Graph';
import API from '../../services/API';
import {NAN_PARAMS, PARAMS_NAME} from "./config";
import {Col, Row} from "react-bootstrap";
import SelectWrap from "../../components/SelectWrap";
import {handleFieldChange} from "../../Utils";

class BidderFeeds extends Component {
    constructor() {
        super();

        this.state = {
            params: [],
            feeds: [],
            sources: [],
            selectedSource: null,
            isLoading: false,
        };

        this.handleFieldChange = handleFieldChange.bind(this);
    }

    componentDidMount() {
        this.setState({ isLoading: true });

        API.BidderFeeds.get().then(({ params, feeds, sources, }) => {
            this.setState({ params, feeds, sources, isLoading: false });
        })
    }

    render() {
        let { isLoading, params, feeds, selectedSource } = this.state;

        if(selectedSource) {
            feeds = feeds.filter(feed => feed[0] === selectedSource);
        }


        return (
            <Container loading={isLoading}>
                <Heading title="Bidder Feeds"/>
                <Row>
                    <Col lg={6}>
                        <SelectWrap
                            values={this.state.sources}
                            label="Sources:"
                            name="selectedSource"
                            onChange={this.handleFieldChange}
                            value={this.state.selectedSource}
                        />
                    </Col>
                </Row>

                <Table params={params} report={feeds} paramNames={PARAMS_NAME} NaNParams={NAN_PARAMS} hideExportButton={true} hideDifferenceCheckbox={true}/>
            </Container>
        );
    }
}

export default BidderFeeds;


// WEBPACK FOOTER //
// ./src/scenes/BidderFeeds/index.js